import React from 'react';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import { AccessibleDivButton } from '@/components';

import { LanguageDropDown } from './LanguageDropDown';
import styles from './AccessibleDrawerHeader.styles';

interface Props {
  title: React.ReactNode;
  titleId: string;
  onClose: () => void;
  selectedLanguage: string;
  onSelectLanguage: (language: string) => void;
  disabled: boolean;
}

export const AccessibleDrawerHeader: React.FC<Props> = ({
  title,
  titleId,
  onClose,
  selectedLanguage,
  onSelectLanguage,
  disabled,
}) => {
  return (
    <header className={styles.container}>
      <div className={styles.headerRow}>
        <div className={styles.languageWrapper}>
          <LanguageDropDown
            selectedLanguage={selectedLanguage}
            setSelectedLanguage={onSelectLanguage}
            disabled={disabled}
          />
        </div>
        <div className={styles.titleWrapper}>{title}</div>
        <AccessibleDivButton aria-label="Close" onClick={onClose} className={styles.closeButton}>
          <CloseOutlinedIcon role="img" aria-hidden="true" />
          <span className="visually-hidden">Close</span>
        </AccessibleDivButton>
      </div>
      <p id={titleId} className="visually-hidden">
        AiDA accessible flyer text
      </p>
    </header>
  );
};
